export default "__VITE_ASSET__C1FSy3Hw__"